import { render, staticRenderFns } from "./CreateStudent.vue?vue&type=template&id=0bcafd19&scoped=true"
import script from "./CreateStudent.vue?vue&type=script&lang=js"
export * from "./CreateStudent.vue?vue&type=script&lang=js"
import style0 from "./CreateStudent.vue?vue&type=style&index=0&id=0bcafd19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcafd19",
  null
  
)

export default component.exports